export default __webpack_public_path__ + "static/media/import-customs-header.cd1eb99d.png";